export enum ConnectionType {
    Star,
    Delta
}
